import { render } from "./product-compare-button.vue?vue&type=template&id=5d6109dc"
import script from "./product-compare-button.vue?vue&type=script&lang=js"
export * from "./product-compare-button.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__